import type { Entities } from "../types"

export const entities: Entities = new Map([])
